import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface CatchUpDialogResult {
  deleteAfterIngest: boolean;
}

@Component({
    selector: 'app-catch-up-dialog',
    templateUrl: './catch-up-dialog.component.html',
    styleUrls: ['./catch-up-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CatchUpDialogComponent {
  deleteAfterIngest = false;

  constructor(private readonly dialogRef: MatDialogRef<CatchUpDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close({ deleteAfterIngest: this.deleteAfterIngest } as CatchUpDialogResult);
  }
}
